import React from 'react';

const NotFoundPage = () => {
    return (
        <h1>Error 404: Page Not Found</h1>
    )
}

export default NotFoundPage;